export default "__VITE_ASSET__D$MiAzxo__"